import _extends from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["showCharacterCount", "maxLength", "value"];
import React from "react";
var __jsx = React.createElement;
import { Textarea } from "@mantine/core";
/** SDS-sized Mantine textarea with an optional character count overlaid at the bottom-right, matching the legacy TextareaInput behaviour. */
export function FormTextarea(_ref) {
  var showCharacterCount = _ref.showCharacterCount,
    maxLength = _ref.maxLength,
    value = _ref.value,
    props = _objectWithoutProperties(_ref, _excluded);
  var currentLength = String(value !== null && value !== void 0 ? value : "").length;
  var countLabel = maxLength != null ? "".concat(currentLength, "/").concat(maxLength) : "".concat(currentLength);
  return /*#__PURE__*/React.createElement("div", {
    className: "relative"
  }, /*#__PURE__*/React.createElement(Textarea, _extends({
    size: "sm",
    maxLength: maxLength,
    value: value
  }, props)), showCharacterCount && /*#__PURE__*/React.createElement("span", {
    className: "pointer-events-none absolute bottom-2 right-3 text-style-label-base text-sds-base-tertiary z-10"
  }, countLabel));
}